import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {Router} from '@angular/router';
import {DataPilotInfoService} from '../utils/data-services/data-pilot-info.service';
import {MatSnackBar} from '@angular/material';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import {DataConcessionService} from '../utils/data-services/dataConcession.service';

@Component({
  selector: 'app-gestion-pilot-info',
  templateUrl: './gestion-pilot-info.component.html',
  styleUrls: ['./gestion-pilot-info.component.scss']
})
export class GestionPilotInfoComponent implements OnInit, AfterViewInit {

  dataSource = new MatTableDataSource();
  displayedColumns = [ 'dealership', 'value', 'startAt', 'endAt', 'brand','url', 'copy', 'stop', 'edit'];
  search = '';
  isInactiveVisible = false;
  completeData = [];
  dealershipArray = [];
  dealershipList = [];
  dealership = 'all';

  constructor(
    private matPaginator: MatPaginator,
    private pilotInfoService: DataPilotInfoService,
    private route: Router,
    private dataConcessionService: DataConcessionService,
    private _snackBar: MatSnackBar,
  ) { }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  ngOnInit() {
    this.getData();
    this.getDealerships();
  }
  ngAfterViewInit() {
    this.matPaginatorTranslate();
    this.paginator.pageIndex = localStorage.getItem('pageIndexPilotInfo') != null ? parseInt(localStorage.getItem('pageIndexPilotInfo')) : null;
    this.paginator.pageSize = localStorage.getItem('pageSizePilotInfo') != null ? parseInt(localStorage.getItem('pageSizePilotInfo')) : null;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  getData(): void {
    this.pilotInfoService.getAll().subscribe(res => {
      this.completeData = res;
      this.dataSource.data = res.filter(x => x.isActive);
      if (this.dealership != 'all') {
        this.dataSource.data = this.dataSource.data.filter((x: any) => x.dealership == this.dealership);
      }
    });
  }
  getDealerships() {
    this.dataConcessionService.getConcession().subscribe(dealership => {
      this.dealershipArray = dealership.records;
      this.dealershipList = dealership.records;
    });
  }
  filterDealership(event): any {
    event.stopPropagation();
    const regexp = new RegExp(event.target.value.toLowerCase());
    this.dealershipArray = this.dealershipList.filter(x => {
      return regexp.exec(x.nom_concession.toLowerCase());
    });
  }
  onApplyFilters(): void {
    this.dataSource.data = this.completeData;
    if (!this.isInactiveVisible) {
      this.dataSource.data = this.dataSource.data.filter((x: any) => x.isActive);
    }
    if (this.dealership != 'all') {
      this.dataSource.data = this.dataSource.data.filter((x: any) => x.dealership == this.dealership);
    }
  }
  onOpenForm(id): void {
    if (id) {
      this.route.navigate(['gestion-pilot-info/update/' + id]);
    } else {
      this.route.navigate(['gestion-pilot-info/create']);
    }
  }
  onStopContent(id): void {
    this.pilotInfoService.stopContent(id).subscribe(res => {
      swal.fire({
        title: 'Success!',
        text: 'Le contenu a bien été arrêté',
        type: 'success',
        confirmButtonText: 'Ok'
      }).then(() => {
        this.getData();
      });
    }, error => {
      swal.fire({
        title: 'Oops...!',
        text: 'Une erreur est surnevue lors de l\'enregistrement..',
        type: 'error',
        confirmButtonText: 'Ok'
      });
    });
  }
  onToggleVisibleInactive(): void {
    this.isInactiveVisible = !this.isInactiveVisible;
    this.onApplyFilters();
  }
  getUrlValue(uniqId): any {
    return environment.pilotStatusUrl + '/i/' + uniqId;
  }
  copyToClipboard(uniqId): void {
    const text = environment.pilotStatusUrl + '/i/' + uniqId;
    navigator.clipboard.writeText(text).then(() => {
      this._snackBar.open('Url copié dans le presse papier');
      setTimeout(() => {
        this._snackBar.dismiss();
      }, 3000);
    }, (err) => {
      console.error('Async: Could not copy text: ', err);
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    localStorage.setItem('pilotInfoFilter', filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource && this.dataSource.data.length > 100 && this.dataSource.paginator) {
      return [20, 50, 100,  this.dataSource.paginator.length];
    } else {
      return [20, 50, 100];
    }
  }
  displayPaginatorAllOption() {
    const matOptions = document.getElementsByClassName('mat-option-text');
    // @ts-ignore
    for (const options of matOptions) {
      options.innerHTML = options.innerHTML == this.dataSource.data.length ? 'Tous' : options.innerHTML;
    }
  }
  pageChange() {
    localStorage.setItem('pageIndexPilotInfo', String(this.paginator.pageIndex));
    localStorage.setItem('pageSizePilotInfo', String(this.paginator.pageSize));
  }
  matPaginatorTranslate(): any {
    // Translate matPaginator to fr-FR
    this.matPaginator._intl.itemsPerPageLabel = 'item par page';
    this.matPaginator._intl.firstPageLabel = 'Première page';
    this.matPaginator._intl.lastPageLabel = 'Dernière page';
    this.matPaginator._intl.nextPageLabel = 'Page suivante';
    this.matPaginator._intl.previousPageLabel = 'Page précédente';
    this.matPaginator._intl.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return '0 de ' + length;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
      return startIndex + 1 + ' - ' + endIndex + ' Sur ' + length;
    };
  }
}
